import {Component, Inject, OnInit} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-user-select-return-station',
  templateUrl: './user-select-return-station.component.html',
  styleUrls: ['./user-select-return-station.component.sass']
})
export class UserSelectReturnStationComponent implements OnInit {

  constructor(
      public dialogRef: MatDialogRef<UserSelectReturnStationComponent>,
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
  }

}
